import React, { useEffect, useState } from 'react'
import LandingWrapper from './LandingWrapper'
import { GetActualiteById } from './Admin/Main/services';
import Fade from 'react-reveal/Fade';
import './styles.css'

export default function Actuality() {

  const [data, setData] = useState(null)

  useEffect(() => {
    const queryString = window.location.href;
    var id = queryString.match(/\/(\d+)$/)[1];

    GetActualiteById(id).then(source => setData(source))
  }, [])

  return (
    <LandingWrapper>
      <Header data={data} />
      <ActualityCard data={data} />
    </LandingWrapper>
  )
}

const Header = ({ data }) => {
  return (
      <React.Fragment>
          <div className="landing-reference__body-content">
              <div className="flip-header-reference">
                  <Fade duration={4000} left>
                      <div className="landing-reference__body-content-left-title">
                          <h1>Les actualités</h1>
                          <p>{data && data.subtitle}</p>
                      </div>
                  </Fade>
              </div>
          </div>
      </React.Fragment>
  )
}

const ActualityCard = ({ data }) => {
  return (
    data ?
      <div className='actuality-container'>
        <a className='come-back' href="/">Revenir a l'accueil</a>
        <h3 className='actuality-subtitle'>{data.title}</h3>

        <div className="landing_api-card-wrapper-white">
          <span>{data.posteddate}</span>

          <div className='actuality-img'>
            <img className='actuality-preview' src={`https://dkbsign.com/dkbsign_web_api/public/storage/actualities/${data.img}`} alt="actuality-img" />
          </div>

          <div className="card-one-paragraph actuality-txt">
            {data.content}
          </div>
        </div>
      </div>
      :
      <div className='not-actuality'>Aucune actualite</div>
  )
}